import { Component, OnInit, Input, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { ClientCertificationBO, PhysicianBO, editcertificate, returnStartOfCareWithCompany } from '../client-parent.model';
import { IMyInputFieldChanged, IMyDateModel, IMyDpOptions } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { GlobalComponent } from 'src/app/global/global.component';
import { FormBuilder } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CommonApiService } from 'src/app/commonapiservice';
import { GeneralService } from 'src/app/service/general.service';
@Component({
  selector: 'app-client-certificate-edit',
  templateUrl: './client-certificate-edit.component.html',
  styleUrls: ['./client-certificate-edit.component.scss']
})
export class ClientCertificateEditComponent implements OnInit {
    private onDestroy$: Subject<void> = new Subject<void>();
    ModelType: string = 'edit';
    @Output() EventEmitFromPhysician = new EventEmitter<number>();
    @Input() certificate: editcertificate = new editcertificate();
    @Output() DatafromCertificate = new EventEmitter<editcertificate>();
    CLientSOCList: returnStartOfCareWithCompany[] = [];
    Physicianvalue: string = "client"
    startofcaredate: boolean = false;
    companyList: [{ Key: number, Value: string }];
    deletecertificate: number = 0;
    ICD10List: [{ Key: string, Value: string }];
    ClientCertificationList = new ClientCertificationBO();
    saveorUpdatecertificationErr: string = "";
    enableICD10: boolean = false;
    enablePhysican: boolean = false;
    certificationCreationinProgress: boolean = false;
    FirstDigitLst: any = []
    SecondDigitLst: any = []
    FrequencyLst: any = []
    PrioritytypeLst: any = []
    PointofOriginLst: any = []
    PatientDischargeLst: any = []
    constructor( public CommonAPI: CommonApiService,public toastrService: ToastrService, public http: HttpClient, public datepipe: DatePipe, public general: GeneralService, private formBuilder: FormBuilder, public global: GlobalComponent, private ref: ChangeDetectorRef) {
      this.global.agencyList();
    }
    ICD10value: string = "client"
  
    ngOnInit(): void {
      if (this.certificate.type != "delete") {
        this.getStartofCareList()
        this.getCompanyList();
        this.getICD10List();
      }
    
      this.ICD10List = this.global.globalICD10List;
      
      if (this.certificate.type == "edit") {
        this.DefaultListCalls()
        this.AddNewCertification("edit");
        this.Certificationdatabind(this.certificate.clientcertifcateData)
        document.getElementById("opencertificate").click();
      }
      if (this.certificate.type == "new") {
        this.DefaultListCalls()
        this.AddNewCertification("new");
        document.getElementById("opencertificate").click();
      }
      if (this.certificate.type == "delete") {
        document.getElementById("deletecertificatedata").click();
        this.deletecertificate = this.certificate.certificateId;
      }
    }
    DefaultListCalls() {
      this.firstdigitLOV()
      this.seconddigitLOV()
      this.FrequencyLOV()
      this.PriorityTYpeLOV()
      this.PointOfLOV()
      this.PatientDischargeLOV()
    }
    AddNewCertification(type: string) {
  
      if (type == 'new') {
        this.ModelType = 'new';
        this.ClientCertificationList = new ClientCertificationBO();
        this.ClientCertificationList.clientId = this.certificate.clientId;
      }
      else {
        this.ModelType = 'edit';
      }
    }
    public myDatePickerOptions: IMyDpOptions = {
      dateFormat: 'mm/dd/yyyy',
      showClearDateBtn: false,
      editableDateField: true
    };
  
    Certificationdatabind(data: ClientCertificationBO) {
  
  
      this.ClientCertificationList = data;
      this.ClientCertificationList.startOfCareId = this.ClientCertificationList.startOfCareId.toString();
      this.ClientCertificationList.icD10PrimaryId = this.ClientCertificationList.icD10PrimaryId.toString();
      // this.ClientCertificationList.startDate = new Date(this.ClientCertificationList.startDate).toLocaleDateString();
      this.ClientCertificationList.startDate= this.datepipe.transform(this.ClientCertificationList?.startDate, "MM/dd/yyyy");
      this.ClientCertificationList.endDate = this.ClientCertificationList.endDate != null ? this.datepipe.transform(this.ClientCertificationList.endDate, "MM/dd/yyyy") : null;
      this.ClientCertificationList.frequncyCodeLid = this.ClientCertificationList.frequncyCodeLid != null ? this.ClientCertificationList.frequncyCodeLid.toString() : null;
      this.ClientCertificationList.firstDigitFacilityLid = this.ClientCertificationList.firstDigitFacilityLid != null ? this.ClientCertificationList.firstDigitFacilityLid.toString() : null
      this.ClientCertificationList.secondDigitFacilityLid = this.ClientCertificationList.secondDigitFacilityLid != null ? this.ClientCertificationList.secondDigitFacilityLid.toString() : null
      this.ClientCertificationList.priorityTypeOfAdmissionLid = this.ClientCertificationList.priorityTypeOfAdmissionLid != null ? this.ClientCertificationList.priorityTypeOfAdmissionLid.toString() : null
      this.ClientCertificationList.pointOfOriginForAdmissionOrVisitLid = this.ClientCertificationList.pointOfOriginForAdmissionOrVisitLid != null ? this.ClientCertificationList.pointOfOriginForAdmissionOrVisitLid.toString() : null
      this.ClientCertificationList.patientDischargeStatusLid = this.ClientCertificationList.patientDischargeStatusLid != null ? this.ClientCertificationList.patientDischargeStatusLid.toString() : null
      if (this.ClientCertificationList.is837I) {
        this.DefaultListCalls()
      }
  
    }
  
  
    //==========================================Date format options===============================//
    Certificationstartdatechange(event: IMyInputFieldChanged) {
      let value = event.value;
      if (value.length == 5 && value.substring(2, 3) != '/') {
  
        this.ClientCertificationList.startDate = value.substring(0, 2) + '/' + value.substring(2, 4) + '/' + value.substring(4, 10);
      }
    }
  
    onDateChangedCertificationStart(event: IMyDateModel) {
      ;
      this.ClientCertificationList.startDate = event.formatted;
  
    }
    Certificationenddatechange(event: IMyInputFieldChanged) {
      let value = event.value;
      if (value.length == 5 && value.substring(2, 3) != '/') {
  
        this.ClientCertificationList.endDate = value.substring(0, 2) + '/' + value.substring(2, 4) + '/' + value.substring(4, 10);
      }
    }
  
    onDateChangedCertificationEnd(event: IMyDateModel) {
      this.ClientCertificationList.endDate = event.formatted;
  
    }
  
  
    //===============================delete certificate==========================================================//
    deleteCertificateConfirmation() {
  
      let params = new URLSearchParams();
      params.append("Id", this.deletecertificate.toString());
      let url = "api/Certification/DeleteCertification?";
      this.CommonAPI.DeleteFunctionForDeleteHttp(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.toastrService.success(
          "Certificate deleted successfully!",
        ), 8000
        document.getElementById('deletecertificatedata').click();
        this.back();
  
      },
        (err: any) => {
  
  
          this.saveorUpdatecertificationErr = "";
          this.saveorUpdatecertificationErr = err;
          if (this.saveorUpdatecertificationErr != "") {
            setTimeout(function () {
              this.saveorUpdatecertificationErr = "";
            }.bind(this), 8000);
  
          }
        });
    }
    //=========================================Search NPI===================================//
    searchNPI(NPI) {
      NPI = NPI != null ? NPI : null;
      let params = new URLSearchParams();
      params.append("searchNPI", NPI);
      let url = "api/Physician/getPhysicianDataFromNpiRegistry?";
      this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: PhysicianBO) => {
        if (data != null) {
          this.ClientCertificationList.physician = data.physicianName;
  
          this.ClientCertificationList.clinicPhone = data.clinicPhone;
          
          this.ClientCertificationList.clinic = data.clinicName != null ? data.clinicName : '' + '' + data.clinicAddress != null ? data.clinicAddress : '' + ',' + data.clinicCity != null ? data.clinicCity : '' + ',' + data.clinicState != null ? data.clinicState : '' + ',' +
            data.zipCode != null ? data.zipCode : '';
  
            this.ClientCertificationList.clinicAddress =data.clinicAddress
            this.ClientCertificationList.clinic=data.clinicAddress
        }
        else {
          this.ClientCertificationList.physician = "";
          this.ClientCertificationList.clinic = "";
          this.ClientCertificationList.clinicAddress ="";
          this.ClientCertificationList.clinicPhone ="";
          this.ClientCertificationList.clinic="";
          this.saveorUpdatecertificationErr = "";
          this.saveorUpdatecertificationErr = "Invalid NPI";
          if (this.saveorUpdatecertificationErr != "") {
            setTimeout(function () {
              this.saveorUpdatecertificationErr = "";
            }.bind(this), 8000);
          }
        }
      }, (err: any) => {
  
        this.ClientCertificationList.physician = "";
        this.ClientCertificationList.clinic = "";
        this.ClientCertificationList.clinicAddress ="";
        this.ClientCertificationList.clinicPhone ="";
        this.saveorUpdatecertificationErr = "";
        this.ClientCertificationList.clinic=""
        this.saveorUpdatecertificationErr = ""
        this.saveorUpdatecertificationErr = err;
        if (this.saveorUpdatecertificationErr != "") {
          setTimeout(function () {
            this.saveorUpdatecertificationErr = "";
          }.bind(this), 8000);
        }
      })
    }
    //=================================Restrict text in text field======================//
    keyPress(event: any) {
      const pattern = /[0-9]/;
      let inputChar = String.fromCharCode(event.charCode);
      if (event.keyCode != 8 && !pattern.test(inputChar)) {
        event.preventDefault();
      }
    }
  
    //==============================check cerficate============================================================//
    checkCertificationValidation(socList) {
      this.certificationCreationinProgress = true;
      socList.socDate = this.CLientSOCList.filter(s => s.startOfCareId == socList.startOfCareId)[0].socDateWithCompanyName
      this.saveorUpdatecertificationErr = "";
  
  
      if (new Date(socList.socDate).getTime() > new Date(socList.startDate).getTime()) {
  
  
        this.saveorUpdatecertificationErr = "Start date should be larger than selected start of care date"
        this.certificationCreationinProgress = false;
        if (this.saveorUpdatecertificationErr != "") {
          setTimeout(function () {
            this.saveorUpdatecertificationErr = "";
          }.bind(this), 8000);
        }
      }
      else if ((socList.endDate != null && socList.endDate != "" && socList.endDate != undefined)
        && (new Date(socList.socDate).getTime() > new Date(socList.endDate).getTime())) {
  
  
        this.saveorUpdatecertificationErr = "End date should be larger than selected start of care date"
        this.certificationCreationinProgress = false;
        if (this.saveorUpdatecertificationErr != "") {
          setTimeout(function () {
            this.saveorUpdatecertificationErr = "";
          }.bind(this), 8000);
        }
      }
      else if ((socList.endDate != null && socList.endDate != "" && socList.endDate != undefined
        && socList.startDate != null && socList.startDate != "" && socList.startDate != undefined)
        && (new Date(socList.startDate).getTime() == new Date(socList.endDate).getTime())) {
  
  
        this.saveorUpdatecertificationErr = "Start date and end date should not be same"
        this.certificationCreationinProgress = false;
        if (this.saveorUpdatecertificationErr != "") {
          setTimeout(function () {
            this.saveorUpdatecertificationErr = "";
          }.bind(this), 8000);
        }
      }
  
      else if ((socList.endDate != null && socList.endDate != "" && socList.endDate != undefined)
        && (new Date(socList.startDate).getTime() > new Date(socList.endDate).getTime())) {
  
  
        this.saveorUpdatecertificationErr = "End date should be larger than selected start of care date"
        this.certificationCreationinProgress = false;
        if (this.saveorUpdatecertificationErr != "") {
          setTimeout(function () {
            this.saveorUpdatecertificationErr = "";
          }.bind(this), 8000);
        }
      }
      else {
        if (this.saveorUpdatecertificationErr == "") {
          this.savephyscian(socList)
  
  
        }
      }
    }
    //===================================save physcian==========================================================//
    savephyscian(socList) {
      if (socList.npi != null && socList.physician != null && socList.npi != undefined && socList.physician != undefined) {
        this.certificationCreationinProgress = true;
        let val = {};
        if (socList.clinic == undefined || socList.clinic == '') {
          socList.clinic = null;
        }
  
        val = {
          Id: socList.Id ? socList.id : '00000000-0000-0000-0000-000000000000',
          NPI: socList.npi,
          PhysicianName: socList.physician,
          ClinicName: socList.clinic != null ? socList.clinic.split(',').length > 0 ? socList.clinic.split(',')[0] : null : null,
          ClinicCity: socList.clinic != null ? socList.clinic.split(',').length > 2 ? socList.clinic.split(',')[2] : null : null,
          ClinicState: socList.clinic != null ? socList.clinic.split(',').length > 3 ? socList.clinic.split(',')[3] : null : null,
          ZipCode: socList.clinic != null ? socList.clinic.split(',').length > 4 ? socList.clinic.split(',')[4] : null : null,
          ClinicPhone: socList.clinicPhone,
          ClinicAddress: socList.clinicAddress
        }
        let url = "api/Physician/SavePhysician?";
        this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(val,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          this.saveClientCertification(socList)
        },
          (err: any) => {
            this.certificationCreationinProgress = false;
            this.saveorUpdatecertificationErr = "";
            this.saveorUpdatecertificationErr = err;
            if (this.saveorUpdatecertificationErr != "") {
              setTimeout(function () {
                this.saveorUpdatecertificationErr = "";
              }.bind(this), 8000);
            }
          });
      }
      else {
        this.saveClientCertification(socList);
      }
    }
    //========================================save certificate===================================================//
    saveClientCertification(data) {
     let socList = JSON.parse(JSON.stringify(data));
  
      if ((socList.startDate != null && socList.startDate != ""&&socList.startDate !=undefined)) {
        this.certificationCreationinProgress = true;
        let val = ""
        if (socList.endDate != null && socList.endDate != undefined && socList.endDate != "") {
          val = this.global.getDateTimeString(socList.endDate);
        }
        else {
          val = null;
        }
        let certObj = {
          Id: socList.id,
          ClientId: this.certificate.clientId,
          StartOfCareId: socList.startOfCareId != null ? socList.startOfCareId : null,
          // StartOfCareId: this.ClientCertificationList.startOfCareId,
          StartDate:this.global.getDateTimeString(socList.startDate),
          EndDate: val,
          CompanyId: socList.companyId != null ?socList.companyId : null,
          // CompanyId: this.ClientCertificationList.companyId,
          NPI: socList.npi,
          Icd10primaryId: this.ICD10List.filter(i => i.Key == socList.icD10PrimaryId)[0].Value,
          Icd10secondaryId: socList.icD10SecondaryId,
          Physician: socList.physician,
          Clinic: socList.clinic,
          is837I: socList.is837I,
          firstDigitFacilityLid: socList.firstDigitFacilityLid ,
          SecondDigitFacilityLid: socList.secondDigitFacilityLid != null ?socList.secondDigitFacilityLid : null,
          FrequncyCodeLid: socList.frequncyCodeLid != null ? socList.frequncyCodeLid : null,
          PriorityTypeOfAdmissionLid: socList.priorityTypeOfAdmissionLid != null ? socList.priorityTypeOfAdmissionLid : null,
          PointOfOriginForAdmissionOrVisitLid: socList.pointOfOriginForAdmissionOrVisitLid != null ? socList.pointOfOriginForAdmissionOrVisitLid : null,
          PatientDischargeStatusLid: socList.patientDischargeStatusLid != null ? socList.patientDischargeStatusLid : null,
          clinicAddress: socList.clinicAddress != null ? socList.clinicAddress : null,
          clinicPhone: socList.clinicPhone != null ? socList.clinicPhone : null,
          referringProvider:socList.referringProvider!=undefined? socList.referringProvider:null,
          referringProvider_NPI: socList.referringProvider_NPI!=undefined? socList.referringProvider_NPI:null,
          referringProvider_FirstName: socList.referringProvider_FirstName!=undefined ?socList.referringProvider_FirstName:null,
          referringProvider_LastName: socList.referringProvider_LastName!=undefined ?socList.referringProvider_LastName:null,
          referringProvider_MiddleName: socList.referringProvider_MiddleName!=undefined ?socList.referringProvider_MiddleName:null,
        }
        let url = "api/Certification/SaveCertification";
        socList.clientId = this.global.clientId;
        if (socList.id == 0) {
          this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(certObj,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any = []) => {
            this.certificationCreationinProgress = false;
            this.toastrService.success('Certificate created successfully!'), 3000;
            document.getElementById("opencertificate").click()
            this.back()
          },
            (err: any) => {
              this.certificationCreationinProgress = false;
              this.saveorUpdatecertificationErr = "";
              this.saveorUpdatecertificationErr = err;
              if (this.saveorUpdatecertificationErr != "") {
                setTimeout(function () {
                  this.saveorUpdatecertificationErr = "";
                }.bind(this), 8000);
              }
            });
        }
  
        else {
          this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(certObj,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any = []) => {
            this.certificationCreationinProgress = false;
            this.toastrService.success('Certificate updated successfully!'), 3000;
            document.getElementById("opencertificate").click()
            this.back();
          },
            (err: any) => {
              this.certificationCreationinProgress = false;
              this.saveorUpdatecertificationErr = "";
              this.saveorUpdatecertificationErr = err;
              if (this.saveorUpdatecertificationErr != "") {
                setTimeout(function () {
                  this.saveorUpdatecertificationErr = "";
                }.bind(this), 8000);
  
              }
            });
        }
      }
  
  
    }
    //=========================================close ICD10================================================================//
    Closedcdialog() {
      document.getElementById("ICD10eopen").click();
    }
    //=========================================get soc date list=============================//
    getStartofCareList() {
      let myParams = new URLSearchParams();
      myParams.append("clientId", this.certificate.clientId.toString());
      let url = "api/StartOfCare/GetStartOfCareDate?"
      this.CommonAPI.GetFunctionwithResponseTypeJson(myParams,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any = []) => {
        this.CLientSOCList = data;
        this.CLientSOCList.forEach(element => {
          element.startOfCareId = element.startOfCareId.toString();
        })
        if (data.length == 0) {
          this.startofcaredate = true;
        }
      })
    }
  
    //=========================================getcompany list=============================//
    getCompanyList() {
      let url = "api/Company/CommonGetCompanyList?";
      this.CommonAPI.GetFunctionwithResponseTypeJson("",url).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: number, Value: string }]) => {
        this.companyList = data;
        this.companyList.forEach(element => {
          element.Value = element.Value;
          element.Key = element.Key;
        })
      })
    }
    //======================================Data from ICD10================================================//
    ICD10data(event) {
      this.ClientCertificationList.icD10PrimaryId = event.toString();
      this.getICD10List();
      document.getElementById("ICD10eopen").click();
      this.enableICD10 = false;
    }
    //////////////////////////////////////Back function///////////////////////////////////////////////////////////////////////
    back() {
      this.DatafromCertificate.emit({
        isView: true,
        isEdit: false,
        certificateId: 0,
        clientcertifcateData: this.certificate.clientcertifcateData,
        clientId: this.global.clientId,
        type: ''
      })
    }
    closeMOdel() {
      document.getElementById("opencertificate").click();
    }
    //===================================Get COmmon Icd10=========================//
    getICD10List() {
      let url = "api/ICD10/commonICDList"
        // let url = "api/ICD10/getICD10List"
      this.CommonAPI.GetFunctionwithResponseTypeJson("",url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any = []) => {
        this.ICD10List = data;
        this.ICD10List.forEach(element => {
          element.Value = element.Value;
          element.Key = element.Key.toString();
        })
      })
    }
    socSelectedEvent(args) {
      if (args == null) {
        this.ClientCertificationList.companyId = '';
      }
      else {
        this.ClientCertificationList.companyId = this.CLientSOCList.filter(s => s.startOfCareId == args)[0].companyId;
      }
    }
    firstdigitLOV() {
      let params = new URLSearchParams();
      params.append("ListCode", "FIRSTDIGITFECILITYCODE");
      let url = "api/LOV/getLovDropDown?";
      this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data:any) => {
        this.FirstDigitLst = data;
      })
    }
    seconddigitLOV() {
      let urlappend = new URLSearchParams();
      urlappend.append("ListCode", "SECONDDIGITFECILITYCODE");
      let url = "api/LOV/getLovDropDown?";
      this.CommonAPI.GetFunctionwithResponseTypeJson(urlappend,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        data.forEach(element => {
          element.id = element.id.toString()
        });
        this.SecondDigitLst = data;
      })
    }
    FrequencyLOV() {
      let urlappend = new URLSearchParams();
      urlappend.append("ListCode", "CLAIMFREQUENCYCODE");
      let url = "api/LOV/getLovDropDown?";
      this.CommonAPI.GetFunctionwithResponseTypeJson(urlappend,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        data.forEach(element => {
          element.id = element.id.toString()
        });
        this.FrequencyLst = data;
      })
    }
    PriorityTYpeLOV() {
      let urlappend = new URLSearchParams();
      urlappend.append("ListCode", "PRIORITYTYPEOFADMINSSION");
      let url = "api/LOV/getLovDropDown?";
      this.CommonAPI.GetFunctionwithResponseTypeJson(urlappend,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        data.forEach(element => {
          element.id = element.id.toString()
        });
        this.PrioritytypeLst = data;
      })
    }
    PointOfLOV() {
      let urlappend = new URLSearchParams();
      urlappend.append("ListCode", "POINTOFORIGINORIGINFORADMISSION");
      let url = "api/LOV/getLovDropDown?";
      this.CommonAPI.GetFunctionwithResponseTypeJson(urlappend,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        data.forEach(element => {
          element.id = element.id.toString()
        });
        this.PointofOriginLst = data;
  
      })
    }
    PatientDischargeLOV() {
      let urlappend = new URLSearchParams();
      urlappend.append("ListCode", "PATIENTDISCHARGESTATUS");
      let url = "api/LOV/getLovDropDown?";
      this.CommonAPI.GetFunctionwithResponseTypeJson(urlappend,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        data.forEach(element => {
          element.id = element.id.toString()
        });
        this.PatientDischargeLst = data;
      })
    }
    is837change() {
      if (!this.ClientCertificationList.is837I) {
        this.ClientCertificationList.firstDigitFacilityLid = null;
        this.ClientCertificationList.secondDigitFacilityLid = null;
        this.ClientCertificationList.frequncyCodeLid = null;
        this.ClientCertificationList.patientDischargeStatusLid = null;
        this.ClientCertificationList.pointOfOriginForAdmissionOrVisitLid = null;
        this.ClientCertificationList.priorityTypeOfAdmissionLid = null;
      }
      else {
        let PatientDischargeval = this.PatientDischargeLst.filter(d => d.lovCode == "30");
        if (this.ClientCertificationList.patientDischargeStatusLid == null || this.ClientCertificationList.patientDischargeStatusLid == '') {
          this.ClientCertificationList.patientDischargeStatusLid = PatientDischargeval.length > 0 ? PatientDischargeval[0].id : null;
        }
        let PointofOriginval = this.PointofOriginLst.filter(d => d.lovCode == "9");
        if (this.ClientCertificationList.pointOfOriginForAdmissionOrVisitLid == null || this.ClientCertificationList.pointOfOriginForAdmissionOrVisitLid == '') {
          this.ClientCertificationList.pointOfOriginForAdmissionOrVisitLid = PointofOriginval.length > 0 ? PointofOriginval[0].id : null;
        }
        let Prioritytype = this.PrioritytypeLst.filter(d => d.lovCode == "1");
        if (this.ClientCertificationList.priorityTypeOfAdmissionLid == null || this.ClientCertificationList.priorityTypeOfAdmissionLid == '') {
          this.ClientCertificationList.priorityTypeOfAdmissionLid = Prioritytype.length > 0 ? Prioritytype[0].id : null;
        }
        let Frequencyval = this.FrequencyLst.filter(d => d.lovCode == "1");
        if (this.ClientCertificationList.frequncyCodeLid == null || this.ClientCertificationList.frequncyCodeLid == '') {
          this.ClientCertificationList.frequncyCodeLid = Frequencyval.length > 0 ? Frequencyval[0].id : null;
        }
        let SecondDigitval = this.SecondDigitLst.filter(d => d.lovCode == "2");
        if (this.ClientCertificationList.secondDigitFacilityLid == null || this.ClientCertificationList.secondDigitFacilityLid == '') {
          this.ClientCertificationList.secondDigitFacilityLid = SecondDigitval.length > 0 ? SecondDigitval[0].id : null;
        }
        let FirstDigit = this.FirstDigitLst.filter(d => d.lovCode == "3");
        if (this.ClientCertificationList.firstDigitFacilityLid == null || this.ClientCertificationList.firstDigitFacilityLid == '') {
          this.ClientCertificationList.firstDigitFacilityLid = FirstDigit.length > 0 ? FirstDigit[0].id : null;
        }
      }
    }
    closePhysicanModal() {
      document.getElementById("PhysicanDetailsopen").click();
      this.enablePhysican = false;
    }
    EmitFromPhysicianData(event) {
      this.ClientCertificationList.npi = event.npi
      this.ClientCertificationList.physician = event.physicianName;
      this.ClientCertificationList.clinicPhone = event.clinicPhone;
      this.ClientCertificationList.clinicAddress = event.clinicAddress
      this.ClientCertificationList.clinic = event.clinicName
      document.getElementById("PhysicanDetailsopen").click();
      this.enablePhysican = false;
    }
    //=======================================Phone number format========================//
    PhysicianPhoneFormat() {
      this.ClientCertificationList.clinicPhone = this.general.converPhoneGoogleLib(this.ClientCertificationList.clinicPhone);
    }
    public ngOnDestroy(): void {
      this.onDestroy$.next();
    }
  

}
